module.exports = __webpack_public_path__ + "static/media/nsm.28035f03.jpg";